import { render, staticRenderFns } from "./GroupStep2.vue?vue&type=template&id=941cae52&"
import script from "./GroupStep2.vue?vue&type=script&lang=ts&"
export * from "./GroupStep2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports